import { connect } from "react-redux";
import get from "lodash/get";

import getDates from "./../services/date.service";
import { handleWinterTimeRange as onHandleChangeStore } from "../../actions/winterMaintenceTimeRangeActions";

const mapStateToProps = (state) => ({
  winterTimeRangeDataState: state.winterMaintenceTimeRange.winterTimeRangeDataState,
  rangeStartDate: get(state, ["winterMaintenceTimeRange", "winterTimeRange", "rangeStartDate"], getDates.getNullTimeDate(new Date())),
  rangeEndDate: get(state, ["winterMaintenceTimeRange", "winterTimeRange", "rangeEndDate"], getDates.getNullTimeDate(new Date())),
  rangeStartTime: get(state, ["winterMaintenceTimeRange", "winterTimeRange", "rangeStartTime"], getDates.getNullTimeDate(new Date())),
  rangeEndTime: get(state, ["winterMaintenceTimeRange", "winterTimeRange", "rangeEndTime"], getDates.getEndDayTimeDate(new Date())),
});

const mapDispatchToProps = {
  onHandleChangeStore,
};

const withWinterTimeRange = (Component) => connect(mapStateToProps, mapDispatchToProps)(Component);

export { withWinterTimeRange };
